import { render, staticRenderFns } from "./user-documents-menu.vue?vue&type=template&id=01e31b42&"
import script from "./user-documents-menu.vue?vue&type=script&lang=js&"
export * from "./user-documents-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports